import { HealthSystemDALModelVetPrinterConfig } from '../api/HealthSystemApi';
import { AnimalType } from './animal';
import { MedicalSupplyMethod } from './injection';

export interface LabelPrintTask {
  id: string;
  status: LabelPrintTaskStatus;
  message: string;
  created: string;
  completed: string;
  supply: LabelPrintSupply;
  farm: LabelPrintFarm;
  order: LabelPrintOrder;
  requestedCount: number;
  printedCount: number;
}

export enum LabelPrintTaskStatus {
  New = 0,
  Error = 10,
  Success = 50
}

export interface LabelPrintSupply {
  number: string;
  amountCC: string;
  withdrawal: string;
  dose: string;
  size: string;
  daysToUse?: number;
  method: MedicalSupplyMethod;
  animalType: AnimalType;
  maxVolumeCC: string;
  minVolumeCC: string;
  startVolume: string;
  incrementStep: string;
  lotNumber?: string;
  treatmentNumber?: string;
  overriddenLotNumber?: string | null;
  overriddenTreatmentNumber?: string | null;
}

export interface LabelPrintFarm {
  number: string;
  name: string;
  address: string;
}

export interface LabelPrintOrder {
  orderNumber: string;
}

export interface PrintCommand {
  payload: LabelPrintCommand;
  config: HealthSystemDALModelVetPrinterConfig;
}

export interface LabelPrintCommand {
  id: string;
  medicalSupply: string;
  animalType: string;
  method: string;
  size: string;
  dose: string;
  minVolumeCC: string;
  maxVolumeCC: string;
  startVolumeCC: string;
  incrementStep: string;
  withdrawal: string;
  withdrawalFor: string;
  orderNumber: string;
  treatNumber: string;
  lotNumber: string;
  vetName: string;
  vetContactName: string;
  regNumber: string;
  vetAddress: string;
  vetPhone: string;
  farmNumber: string;
  farmName: string;
  farmAddress: string;
  date: string;
  daysToUse: string;
}
export enum CommunicationType {
  Usb = 0,
  TcpIp = 1,
  Driver = 2
}

export interface LogLineResult {
  isSuccess: boolean;
  messageId: string;
  parameters: string[];
}
